document.addEventListener('DOMContentLoaded', function () {
    const isFaqContainer = document.querySelector('.faq-container');
    const questionsAccordions = document.querySelectorAll('.questions-accordion');
    if (questionsAccordions && isFaqContainer) {
        questionsAccordions.forEach(questionBlock => {
            const questionTop = questionBlock.querySelector('.questions-accordion__top');
            const questionContent = questionBlock.querySelector('.questions-accordion__content--faq-page');
            const icon = questionBlock.querySelector('.questions-accordion__icon');
            questionTop.addEventListener('click', (e) => {
                // Fermez tous les autres accordéons sauf celui qui est cliqué
                const allQuestionContents = document.querySelectorAll('.questions-accordion__content--faq-page');
                allQuestionContents.forEach(questionContentOpen => {
                    if (questionContentOpen !== questionContent) {
                        questionContentOpen.parentElement.querySelector('.questions-accordion__icon').classList.remove('is-open');
                        questionContentOpen.classList.remove('is-open');
                    } else {
                        icon.classList.toggle('is-open');
                        questionContent.classList.toggle('is-open');
                    }

                });
            });
        });
    }
})